import React from "react";
import CareerNav from "../../components/Navbar/CarrerNav";
import Footer from "../../components/Home/footer/Footer";
import { Helmet } from "react-helmet";
import {
  curiosity,
  hiring,
  innovative,
  leadership,
  obsession,
  trust,
} from "../../Assets";

const LeaderShip = () => {
  return (
    <>
      <Helmet>
        <title>
          {" "}
          Avijobs Leadership Principles: Guiding Our Mission in Healthcare
        </title>
        <meta
          name='discription'
          content=' Our leadership principles drive Avijobs vision of making workspace efficient. Learn how we prioritize innovation, customer focus, and long-term thinking.'
        />
      </Helmet>
      <div className='App'>
        <CareerNav />
        <Header />
        <Section />
        <LearnMore />
        <Footer />
      </div>
    </>
  );
};

const Header = () => (
  <header className='hero bg-white p-12'>
    <div class='flex items-center justify-between p-10 md:flex-row'>
      <div className='w-50 flex h-full flex-col p-12'>
        <div className='flex-grow'>
          <h2 className='text-4xl'>Our Leadership Principles</h2>
          <span className='text-lg'>
            We are committed to fostering a workplace where diversity, equity,
            and inclusion are not just values, but integral aspects of our
            company culture. We believe that a diverse team, enriched by
            different backgrounds, experiences, and perspectives, drives
            innovation and creativity.
          </span>
        </div>
      </div>
      <div className='w-50 ml-20 rounded-lg object-cover p-4'>
        <img
          src={leadership}
          alt='leadership principles'
          style={{ width: "100%", height: 300 }}
          className='rounded-lg'
        />
      </div>
    </div>
  </header>
);

const Section = () => {
  return (
    <div className='flex flex-col items-center p-9'>
      <div className='flex items-center justify-between p-8 md:flex-row'>
        <div className='w-[50%] p-4'>
          <img
            src={obsession}
            alt='Obsession'
            className='h-[400px] w-full rounded-lg object-cover'
          />
        </div>
        <div className='w-[50%] flex-grow px-6 text-justify'>
          <h4 className='text-3xl font-semibold text-[#5D5D5D]'>
            Citizens Obsession
          </h4>
          <ul className='mt-3 list-disc pl-6'>
            <li className='text-lg leading-relaxed'>
              Our primary focus is on our users—both employees and customers. We
              strive to understand their needs, exceed their expectations, and
              provide the best possible experience. Everything we do is driven
              by a commitment to put our users first, ensuring that our services
              and culture revolve around their satisfaction and well-being.
            </li>
          </ul>
        </div>
      </div>
      <div className='mt-4 h-[2px] w-[90%] bg-gray-200' />
    </div>
  );
};

const LearnMore = () => {
  const learnMoreData = [
    {
      image: curiosity,
      alt: "Teams",
      title: "Learn with Curiosity",
      text: "We believe in continuous learning and curiosity-driven growth. Our team members are encouraged to explore new ideas, stay updated with the latest trends, and constantly seek out ways to improve. This principle fosters an environment where innovation thrives, and everyone is empowered to contribute creatively to our collective success.",
    },
    {
      image: hiring,
      alt: "Job Categories",
      title: "Hire and Develop the Best",
      text: "We are committed to building a team of exceptional talent. By hiring the best and providing opportunities for continuous development, we ensure that our team members grow both personally and professionally. We believe in nurturing potential, recognizing achievements, and creating leaders within the organization.",
    },
    {
      image: innovative,
      alt: "innovative",
      title: "Think Big, Innovate, and Simplify",
      text: "We encourage our team to think beyond the ordinary and embrace bold ideas. Innovation is at the core of our strategy, and we aim to simplify complex challenges through creative solutions. By thinking big, we set ambitious goals and continuously push the boundaries of what's possible.",
    },
    {
      image: trust,
      alt: "trust",
      title: "Earn Trust",
      text: "Trust is the foundation of all our relationships—whether with employees, customers, or partners. We believe in transparency, integrity, and delivering on our promises. By consistently acting with honesty and responsibility, we earn and maintain the trust of everyone we engage with.",
    },
  ];

  const LearnMoreItem = ({ item }) => {
    const { image, alt, title, text } = item;
    return (
      <div className='learn-more-item'>
        <img src={image} alt={alt} className='learn-more-img' loading='lazy' />
        <h6 className='learn-more-title'>{title}</h6>
        <p className='learn-more-text'>{text}</p>
      </div>
    );
  };

  return (
    <section className='flex flex-col items-center bg-white py-5'>
      <div className='explore container'>
        <h3 className='font-[Gilroy-SemiBold] text-[#636363]'>
          We Think & Learn More Than We Work
        </h3>
        <div className='learn-more-content'>
          {learnMoreData.map((item, index) => (
            <LearnMoreItem item={item} key={index} />
          ))}
        </div>
      </div>
      <div className='h-[2px] w-[90%] bg-gray-50' />
    </section>
  );
};

export default LeaderShip;
